'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DRAG_START = exports.DRAG_START = 'DRAG_START';
var DRAG_END = exports.DRAG_END = 'DRAG_END';
var DRAG_OVER = exports.DRAG_OVER = 'DRAG_OVER';


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/draggingConstants.js
// module id = 143
// module chunks = 0